import { useFormik } from 'formik';
import Heading from '../../../../components/Heading/Heading';
import styles from '../../Users/Create User/CreateUser.module.css';
import infoIcon from '../../../../assets/img/info.svg';
import Icon from '../../../../components/Icon/Icon';
import { InputText } from 'primereact/inputtext';
import Error from '../../../../components/Error/Error';
import { Tooltip } from 'primereact/tooltip';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import CONSTANTS from '../../../../constants';
import { createUserRoleSchema } from '../../../../schemas';
import {
	generateApprovedUserRoles,
	modifyApprovedUserRole,
	submitNewUserRole,
} from '../../../../utils/common.utils';
import { useEffect, useState } from 'react';
import Toggle from '../../../../components/Toggle/Toggle';
import { Divider } from 'primereact/divider';
import { useCallback } from 'react';

const CreateUserRole = (props) => {
	const { isEditable, roleName } = props;

	const [permissionGroupList, setPermissionGroupList] = useState([]);

	const [showDetails, setShowDetails] = useState(false);
  const filterPermissionGroupList = useCallback((list) => {
	const excludePermissionGroups = new Set(["Tenant Admin"]);
	setPermissionGroupList(list.filter(x => !excludePermissionGroups.has(x?.permissionGroup)));
  }, []);

	const {
		values,
		errors,
		touched,
		handleBlur,
		handleChange,
		handleSubmit,
		setFieldValue,
	} = useFormik({
		initialValues: CONSTANTS.initialCreateUserRoleValue,
		validationSchema: createUserRoleSchema,
		onSubmit: (values, action) => {
			isEditable ? modifyApprovedUserRole(values) : submitNewUserRole(values);
			action.resetForm();
		},
	});

	useEffect(() => {
		generateApprovedUserRoles(filterPermissionGroupList, true);
		setFieldValue('roleName', roleName);
	}, [filterPermissionGroupList, roleName, setFieldValue]);

	const permissionGroups = permissionGroupList.map(
		(pGroup) => pGroup.permissionGroup
	);

	// console.log(permissionGroupList);

	return (
		<div className={isEditable ? '' : 'main'}>
			{isEditable ? '' : <Heading>Create User Role</Heading>}
			<form
				className={`${styles['create-user__container']} ${styles.card}`}
				onSubmit={handleSubmit}
			>
				<div className={styles.card}>
					<h3>User Role Details</h3>
					<div className={styles.form}>
						{/* Role Name */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="roleName" className={styles['input-label']}>
									Role Name:
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} roleName-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Enter your role name to create the user role."
								/>
							</div>
							<Tooltip target=".roleName-tooltip" className={styles.tooltip} />
							<div className="p-inputgroup">
								<Icon icon="person" className="p-inputgroup-addon" />
								<InputText
									className={`${
										touched.roleName && errors.roleName ? 'p-invalid' : ''
									} styles.input`}
									id="roleName"
									name="roleName"
									disabled={isEditable}
									placeholder="Enter your user role name"
									value={values.roleName}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
							</div>
							{touched.roleName && errors.roleName ? (
								<Error>{errors.roleName}</Error>
							) : null}
						</div>
						{/* Role Description */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label
									htmlFor="roleDescription"
									className={styles['input-label']}
								>
									Role Description:
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} roleDescription-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Enter the description to create the user role."
								/>
							</div>
							<Tooltip
								target=".roleDescription-tooltip"
								className={styles.tooltip}
							/>
							<div className="p-inputgroup">
								<Icon icon="description" className="p-inputgroup-addon" />
								<InputText
									className={`${
										touched.roleDescription && errors.roleDescription
											? 'p-invalid'
											: ''
									} styles.input`}
									id="roleDescription"
									name="roleDescription"
									placeholder="Enter role description"
									value={values.roleDescription}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
							</div>
							{touched.roleDescription && errors.roleDescription ? (
								<Error>{errors.roleDescription}</Error>
							) : null}
						</div>
						{/* PermissionGroupList (to be fetched from API) */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label
									htmlFor="permissionGroupList"
									className={styles['input-label']}
								>
									Select permission group(s):
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} permissionGroupList-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Select the permission(s) for the user role"
								/>
							</div>
							<Tooltip
								target=".permissionGroupList-tooltip"
								className={styles.tooltip}
							/>
							<div className="p-inputgroup">
								<Icon icon="api" className="p-inputgroup-addon" />
								<MultiSelect
									inputId="permissionGroupList"
									name="permissionGroupList"
									placeholder="Select the permission group(s)"
									value={values.permissionGroupList}
									onChange={handleChange}
									onBlur={handleBlur}
									options={permissionGroups}
								/>
							</div>
							{touched.permissionGroupList && errors.permissionGroupList ? (
								<Error>{errors.permissionGroupList}</Error>
							) : null}
							<Toggle
								checked={showDetails}
								handleChange={() => setShowDetails(!showDetails)}
								className={styles.toggle}
							/>
						</div>
						{/* Toggle */}
						<div className={styles['next-button__container']}>
							<Button className={styles['submit-button__alt']}>
								Submit User Role Details
							</Button>
						</div>
						{showDetails ? (
							<div>
								<div className={styles.divider}>
									<h3>Permission Groups with their group APIs</h3>
									<Divider />
								</div>
								<div className={styles['permission__container']}>
									{permissionGroupList.map((pG) => (
										<div
											key={pG.permissionGroup}
											className={styles['permission-group']}
										>
											<div className={styles['group-name']}>
												{pG.permissionGroup}
											</div>
											{/* <div>List of APIs</div> */}
											<div className={styles['api-list']}>
												{pG.groupApis.map((api) => (
													<div key={api} className={styles.api}>
														{api}
													</div>
												))}
											</div>
										</div>
									))}
								</div>
							</div>
						) : null}
					</div>
				</div>
			</form>
		</div>
	);
};

export default CreateUserRole;
